/* eslint-disable consistent-return */
import t from './DamFolder.type';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import * as DamFolderService from '../../../../../services/dam-product-folder.service';
import { ERROR_MESSAGE } from '../../../../../Components/helper';

export const fetchDamProductFolders = (params) => {
  return async (dispatch) => {
    try {
      const response = await DamFolderService.fetchDamProductFolder(params);
      if (response.code === 200) {
        dispatch({
          type: t.SET_PRODUCT_FOLDERS,
          payload: {
            ...params,
            data: response?.data.doc,
            totalCount: response?.data?.totalCount,
          },
        });
      }
      return response;
    } catch (error) {
      toasterMsg(ERROR_MESSAGE, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const filterDamFolderSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.DAM_PRODUCT_FOLDER_SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const filterDamFolderFilesSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.DAM_PRODUCT_FOLDER_FILES_SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteProductDamFolderByIdAction = (params, transactionMsg) => async () => {
  try {
    const res = await DamFolderService.deleteProductDamFiles(params);
    if (res && res.code === 200) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);

      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else {
      toasterMsg(res.message, 'danger');
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
